// extracted by mini-css-extract-plugin
export var container = "_dt-0";
export var icon = "_dt-1";
export var text = "_dt-2";